/*
 * @Author: lishiqiao
 * @Date: 2022-01-17 17:53:28
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-07-21 09:36:00
 */
import http from "@/axios/index";
import Page from "@/utils/methods/page"

export default {
    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:55:14
     * @description: 产量--查询顶级机构下的所有机构
     * @param {*} rootId
     */
    getOutPutCompanyList(rootId) {
        const url = `/desktopReport/queryRewardtOrg/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:56:15
     * @description: 产量--查询顶级机构下的所有品种
     * @param {*} rootId
     */
    getOutPutBreedList(rootId) {
        // const url = `/desktopReport/queryRewardtBreed/${rootId}`; // 旧
        const url = `/desktopReport/queryRewardBreed/egg/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:57:09
     * @description: 塘口收获情况--查询顶级机构下的所有养殖场
     * @param {*} params
     */
    getPondBaseList(params) {
        const url = `/desktopReport/queryBoxOrg`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 18:02:46
     * @description: 塘口收获情况--查询顶级机构下的所有批次
     * @param {*} params
     */
    getPondBatchList(params) {
        const url = `/desktopReport/queryBoxBatch`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 18:03:19
     * @description: 塘口收获情况--查询顶级机构下的所有品类
     * @param {*} params
     */
    getPondBreedTypeList(params) {
        const url = `/desktopReport/queryBoxType`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 18:03:45
     * @description: 塘口收获情况--查询顶级机构下的所有品种
     * @param {*} params
     */
    getPondBreedList(params) {
        const url = `/desktopReport/queryBoxBreed`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 18:05:21
     * @description: 收获概览-产量报表-育苗日期分页
     * @param {*} params
     */
    getOutPutPageList(params) {
        const url = `/outHarvestDailyOrg/searchOutHarvestDailyOrgList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 18:05:58
     * @description: 收获概览-产量报表分页-（养成、育苗）分页导出
     * @param {*} params
     */
    exportOutPutData(params) {
        const url = `/outHarvestDailyOrg/exportOutHarvestDailyOrgList`;
        return Page.exportDatas(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 18:06:40
     * @description: 收获概览-塘口收获情况-（养成、育苗）分页
     * @param {*} params
     */
    getPondPageList(params) {
        const url = `/mdtPondHarvest/searchMdtPondHarvestList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 18:07:18
     * @description: 收获概览-塘口收获情况-（养成、育苗）分页导出
     * @param {*} params
     */
    exportPondData(params) {
        const url = `/mdtPondHarvest/exportMdtPondHarvestList`;
        return Page.exportDatas(url, params)
    },
}